<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'

    >
      <v-card-text>
        <span v-if='!estimateDetail.mech_schedule_considerations'>None...</span>
        <span v-html='estimateDetail.mech_schedule_considerations'></span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-textarea
        v-model='estimateDetailCopy.mech_schedule_considerations'
        outlined
        auto-grow
        hint='Office use only - for the mechanical work order'
        persistent-hint
      ></v-textarea>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'mechanical-schedule-considerations',
  props: {
    estimate: {
      required: true
    },
    estimateDetail: {
      required: true
    }
  },
  data: () => ({
    icon: 'mdi-calendar-text',
    iconColor: '#b87333',
    estimateDetailCopy: {},
    showDialog: false
  }),
  computed: {
    title () {
      return 'Mech. Sched. Considerations'
    }
  },
  methods: {
    openEdit () {
      this.estimateDetailCopy = _.cloneDeep(this.estimateDetail)
      this.showDialog = true
    },
    save () {
      this.$emit('updateDetail', this.estimateDetailCopy)
      this.showDialog = false
    }
  }
}
</script>